import { apiClient } from './apiClient';

export interface UserStats {
  daily: number;
  monthly: number;
  yearly: number;
  totalActive: number;
}

export interface RecentUser {
  id: number;
  username: string;
  email: string;
  dateJoined: string;
  isActive: boolean;
  profilePhoto: string | null;
}

export interface User {
  id: number;
  username: string;
  email: string;
  isActive: boolean;
  isSuperuser: boolean;
  isStaff: boolean;
  dateJoined: string;
  shadowBannedUntil: string | null;
  isShadowBanned: boolean;
  profilePhoto: string | null;
}

export interface UserListResponse {
  data: User[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const usersService = {
  async getStats(): Promise<UserStats> {
    return apiClient.get<UserStats>('/users/stats');
  },
  async getRecentUsers(days: number): Promise<RecentUser[]> {
    return apiClient.get<RecentUser[]>(`/users/recent?days=${days}`);
  },
  async searchUsers(
    search?: string,
    page: number = 1,
    limit: number = 20,
  ): Promise<UserListResponse> {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    params.append('page', page.toString());
    params.append('limit', limit.toString());
    return apiClient.get<UserListResponse>(`/users?${params.toString()}`);
  },
  async activateUser(id: number): Promise<void> {
    return apiClient.patch(`/users/${id}/activate`, {});
  },
  async deactivateUser(id: number): Promise<void> {
    return apiClient.patch(`/users/${id}/deactivate`, {});
  },
  async sendPasswordResetEmail(id: number): Promise<void> {
    return apiClient.post(`/users/${id}/send-password-reset`, {});
  },
  async updateShadowBanDate(
    id: number,
    shadowBannedUntil: Date | null,
  ): Promise<void> {
    return apiClient.patch(`/users/${id}/shadow-ban`, {
      shadowBannedUntil: shadowBannedUntil
        ? shadowBannedUntil.toISOString()
        : null,
    });
  },
};
